<div class="vtz-modal" id="submit-modal">
    <img i18n-alt="icon alert alt-text" alt="icon alert" src="/assets/images/icon_alert.svg" />
  <div class="vtz-modal-content">
    <h1 mat-dialog-title i18n class="vtz-modal-title">Session Timeout Warning</h1>
    <mat-dialog-content i18n class="vtz-modal-body vtz-modal-body--narrow">Your session will end in {{sessionService.secondsRemaining}} seconds due to inactivity, click “Continue” to extend the session</mat-dialog-content>
  </div>
  <mat-dialog-actions class="dialog-button-container">
    <button id="logout-button" i18n class="button-secondary button-narrow-screen" (click)="endSession()" i18n>EXIT</button>
    <div class="vtz-spacer-10"></div>
    <button id="continue-button" i18n class="button-primary button-narrow-screen" [disabled]="continueButtonDisabled.getValue()" (click)="refreshSession()" cdkFocusInitial i18n>CONTINUE</button>
  </mat-dialog-actions>
</div>
